import { render, staticRenderFns } from "./ListComponent.vue?vue&type=template&id=67ed75dc&scoped=true&"
import script from "./ListComponent.vue?vue&type=script&lang=js&"
export * from "./ListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed75dc",
  null
  
)

export default component.exports